import React, { useState } from 'react';

const TransferItemsList = ({ items, onRemoveItem, onUpdateQuantity }) => {
    const [editingItem, setEditingItem] = useState(null);
    const [editQuantity, setEditQuantity] = useState('');

    const totalAmount = items.reduce((sum, item) => sum + (item.donGia * item.soLuongDieuChuyen), 0);

    const handleEditStart = (item) => {
        setEditingItem(item.maSP);
        setEditQuantity(item.soLuongDieuChuyen.toString());
    };

    const handleEditSave = (maSP) => {
        const newQuantity = parseFloat(editQuantity);
        if (newQuantity > 0) {
            onUpdateQuantity(maSP, newQuantity);
        }
        setEditingItem(null);
        setEditQuantity('');
    };

    const handleEditCancel = () => {
        setEditingItem(null);
        setEditQuantity('');
    };

    return (
        <div className="card">
            <div className="card-header">
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <i className="fas fa-list-alt" style={{ fontSize: '20px', color: '#1976d2' }}></i>
                    <div>
                        <h3 className="mb-0">Danh sách sản phẩm điều chuyển</h3>
                        <small className="text-muted">
                            {items.length > 0 ? `${items.length} sản phẩm được chọn` : 'Chưa có sản phẩm nào'}
                        </small>
                    </div>
                </div>
            </div>
            <div className="card-body">
                {items.length === 0 ? (
                    <div style={{ 
                        textAlign: 'center', 
                        padding: '60px 20px',
                        background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                        borderRadius: '12px',
                        border: '2px dashed #dee2e6'
                    }}>
                        <i className="fas fa-shopping-cart" style={{ 
                            fontSize: '48px', 
                            color: '#adb5bd',
                            marginBottom: '16px'
                        }}></i>
                        <h4 style={{ color: '#6c757d', marginBottom: '8px' }}>Danh sách trống</h4>
                        <p className="text-muted" style={{ fontSize: '14px' }}>
                            Chọn sản phẩm từ danh mục để thêm vào danh sách điều chuyển
                        </p>
                    </div>
                ) : (
                    <>
                        <div className="table-responsive">
                            <table className="table table-striped">
                                <thead>
                                    <tr>
                                        <th style={{ width: '12%', fontSize: '13px', fontWeight: '600' }}>
                                            <i className="fas fa-barcode me-2"></i>Mã SP
                                        </th>
                                        <th style={{ width: '30%', fontSize: '13px', fontWeight: '600' }}>
                                            <i className="fas fa-tag me-2"></i>Tên sản phẩm
                                        </th>
                                        <th style={{ width: '10%', fontSize: '13px', fontWeight: '600' }}>
                                            <i className="fas fa-ruler me-2"></i>ĐVT
                                        </th>
                                        <th style={{ width: '15%', fontSize: '13px', fontWeight: '600' }}>
                                            <i className="fas fa-dollar-sign me-2"></i>Đơn giá
                                        </th>
                                        <th style={{ width: '13%', fontSize: '13px', fontWeight: '600' }}>
                                            <i className="fas fa-sort-numeric-up me-2"></i>Số lượng
                                        </th>
                                        <th style={{ width: '15%', fontSize: '13px', fontWeight: '600' }}>
                                            <i className="fas fa-calculator me-2"></i>Thành tiền
                                        </th>
                                        <th style={{ width: '5%', fontSize: '13px', fontWeight: '600' }}>
                                            <i className="fas fa-cogs me-2"></i>Thao tác
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {items.map(item => (
                                        <tr key={item.maSP} style={{ 
                                            transition: 'background-color 0.2s ease'
                                        }}>
                                            <td style={{ fontSize: '13px', fontWeight: '500' }}>
                                                {item.maSP}
                                            </td>
                                            <td style={{ fontSize: '13px' }}>
                                                <strong>{item.ten_SP}</strong>
                                            </td>
                                            <td style={{ fontSize: '13px' }}>
                                                <span className="badge bg-secondary" style={{ fontSize: '11px' }}>
                                                    {item.dvt_SP}
                                                </span>
                                            </td>
                                            <td style={{ fontSize: '13px', color: '#1976d2', fontWeight: '500' }}>
                                                {item.donGia?.toLocaleString()} VND
                                            </td>
                                            <td style={{ fontSize: '13px' }}>
                                                {editingItem === item.maSP ? (
                                                    <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
                                                        <input
                                                            type="number"
                                                            value={editQuantity}
                                                            onChange={(e) => setEditQuantity(e.target.value)}
                                                            className="form-control form-control-sm"
                                                            style={{ width: '80px', fontSize: '12px' }}
                                                            min="0"
                                                            step="0.01"
                                                            autoFocus
                                                        />
                                                        <div style={{ display: 'flex', gap: '2px' }}>
                                                            <button 
                                                                onClick={() => handleEditSave(item.maSP)}
                                                                className="btn btn-primary"
                                                                style={{ 
                                                                    padding: '2px 6px', 
                                                                    fontSize: '10px',
                                                                    minWidth: 'auto'
                                                                }}
                                                                title="Lưu"
                                                            >OK
                                                                <i className="fas fa-check"></i>
                                                            </button>
                                                            <button 
                                                                onClick={handleEditCancel}
                                                                className="btn btn-secondary"
                                                                style={{ 
                                                                    padding: '2px 6px', 
                                                                    fontSize: '10px',
                                                                    minWidth: 'auto'
                                                                }}
                                                                title="Hủy"
                                                            >X
                                                                <i className="fas fa-times"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                        <strong style={{ color: '#28a745' }}>
                                                            {item.soLuongDieuChuyen}
                                                        </strong>
                                                        <button 
                                                            onClick={() => handleEditStart(item)}
                                                            className="btn btn-outline-primary"
                                                            style={{ 
                                                                padding: '2px 6px', 
                                                                fontSize: '10px',
                                                                minWidth: 'auto'
                                                            }}
                                                            title="Sửa số lượng"
                                                        > Sửa
                                                            <i className="fas fa-edit"></i>
                                                        </button>
                                                    </div>
                                                )}
                                            </td>
                                            <td style={{ fontSize: '13px', fontWeight: '600', color: '#28a745' }}>
                                                {(item.donGia * item.soLuongDieuChuyen).toLocaleString()} VND
                                            </td>
                                            <td>
                                                <button 
                                                    onClick={() => onRemoveItem(item.maSP)}
                                                    className="btn btn-danger btn-sm"
                                                    style={{ 
                                                        padding: '4px 8px',
                                                        fontSize: '11px'
                                                    }}
                                                    title="Xóa khỏi danh sách"
                                                > X
                                                    <i className="fas fa-trash"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        
                        {/* Total Summary */}
                        <div style={{ 
                            marginTop: '24px', 
                            padding: '20px', 
                            background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)',
                            borderRadius: '12px',
                            color: 'white',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}>
                            <div>
                                <h5 style={{ margin: '0 0 4px 0', fontWeight: '600' }}>
                                    <i className="fas fa-calculator me-2"></i>
                                    Tổng kết điều chuyển
                                </h5>
                                <p style={{ margin: 0, fontSize: '14px', opacity: 0.9 }}>
                                    {items.length} sản phẩm được chọn
                                </p>
                            </div>
                            <div style={{ textAlign: 'right' }}>
                                <div style={{ fontSize: '14px', opacity: 0.9, marginBottom: '4px' }}>
                                    Tổng giá trị
                                </div>
                                <div style={{ fontSize: '24px', fontWeight: '700' }}>
                                    {totalAmount.toLocaleString()} VND
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default TransferItemsList;
